module.exports = __webpack_public_path__ + "static/media/app-qr-code.c4bc0843.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/app-qr-code.gif
// module id = 121
// module chunks = 0